<template>
  <div class="AlterCmp full-height linear-main3">
    <ld-header transparent white @click-left="$router.push({ path: '/allorder', query: { findType: '4' } })">
      改签申请完成
    </ld-header>

    <van-pull-refresh class="wrapper" v-model="isLoading" @refresh="getDetail">
      <div class="white pad8">
        <van-row class="font-lg font24 mt5">
          <ld-icon :type="detail.showSendCkButton == 1 ? 'iconshenpi1' :
          detail.showPayButton == 1 ? 'iconzhifu' :
          'icondingzuoshj-icon-Reser'" size="30" class="order-status__icon" />
          {{ detail.changeStatusName }}
        </van-row>
        <van-row class="font12 mt5">
          {{ detail.changeStatusDescDetail }}
        </van-row>
      </div>

      <div class="pad8" v-if="detail.orderNo">
        <van-row class="round-sm pad8 van-row bg-white">
          改签单号：{{ detail.orderNo }}

          <router-link class="main-color fr" :to="`/tr/ChangeDetail/${detail.changeId}`">
            {{ $t('B011', '查看订单') }}
          </router-link>
        </van-row>

        <!-- 改签后火车信息 -->
        <div class="round-sm mt5 bg-white">
          <van-row v-if="detail.takeTicketCode" class="font12 pad8 gray">
            <van-tag type="warning">
              改
            </van-tag>
            取票号：{{ detail.takeTicketCode }}
          </van-row>
          <stop-station class="bg-white van-hairline--bottom" :detail="detail.newDetail" train-no-class="main-color" />
        </div>

        <!-- 经停信息 -->
        <div class="round-sm mt5 bg-white">
          <van-row v-if="detail.takeTicketCode" class="font12 pad8 gray">
            <van-tag type="primary">
              原
            </van-tag>
          </van-row>
          <stop-station class="bg-white van-hairline--bottom" :detail="detail.oldDetail" />
        </div>

        <!-- 乘车人列表 -->
        <van-cell-group class="mt5 round-sm">
          <psg-panel v-for="(passenger, i) in detail.psgList" :key="i" :passenger="passenger" />
        </van-cell-group>

        <ld-button class="mt5" detault to="/home">
          {{ $t('B012', '继续预订') }}
        </ld-button>
      </div>
    </van-pull-refresh>


    <!-- 底部导航 -->
    <ld-tabbar ref="tabbar" :price-list="priceList">
      <van-row class="full-width bg-white shadow" type="flex" align="center" @click="$refs['tabbar'].toggle()">
        <van-col span="5" :offset="1">
          改签费用：
        </van-col>
        <van-col span="6">
          <span class="font10 red">&yen;</span>
          <span class="font24 red">{{ detail.changeAmount }}</span>
        </van-col>
        <van-col span="6" class="pad5">
          <ld-button main size="md" v-if="detail.showSendCkButton == 1" @click.native="btnClick('approval')">
            {{ $t('B028', '送审') }}
          </ld-button>



          <ld-button defaults size="md" class="font12" v-if="detail.showCancelButton == 1 && detail.showPayButton != 1"
                     @click.stop="btnClick('cancel')">
            {{ $t('B008', '取消') }}
          </ld-button>

        </van-col>



        <van-col span="6" class="pad5">
          <ld-button main size="md" class="font12" v-if="detail.showConfirmButton == 1"
                     @click.stop="btnClick('confirmChange')" style="height: 34px;width: 85px; ;">
            {{ $t('B050', '确认改签') }}
          </ld-button>
          <ld-button main size="md" v-else-if="detail.showPayButton == 1" @click.native="pay">
            {{ $t('B014', '支付') }}
          </ld-button>
        </van-col>




      </van-row>
    </ld-tabbar>

    <!-- 支付 -->
    <!-- <ld-pay
      ref="pay"
      :order-type="detail.orderType"
      :order-id="id"
    /> -->
  </div>
</template>

<script>
/**
 * @file 火车票改签完成页面
 * @param {String} id 火车票订单
 */
import { CellGroup, Cell, PullRefresh, Tag } from 'vant'
import ldButton from 'Common/ldButton'
import ldTabbar from 'Components/ldTabbar/ldTabbar'
import StopStation from '../trQuery/StopStation'
// import ldPay from 'Components/ldPay/index.vue'
import PsgPanel from '../trOrder/PsgPanel'
import handle from './handle'

import TrainOrderInteractor from 'Domain/use-cases/train-order-interactor'

export default {
  components: {
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    [PullRefresh.name]: PullRefresh,
    [Tag.name]: Tag,
    ldButton,
    ldTabbar,
    StopStation,
    PsgPanel,
    // ldPay
  },
  props: {
    id: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      isLoading: false,
      detail: {}, // 正常单详情
      time: 5,
      timer: null,
    }
  },
  created () {
    this.getDetail()

    // 卧铺多人改签是生成多个订单 显示第一个人的信息
    this.id = this.id.split(',')[0]
  },
  methods: {
    async getDetail () {
      this.isLoading = true

      let { data } = await TrainOrderInteractor.getChangeDetailById(this.id)

      this.isLoading = false
      this.detail = data
    },
    pay () {
      this.$router.push({ path: '/pay/payment', query: { orderType: this.detail.orderType, orderId: this.id } })
      // this.$refs.pay.toggle()
    },
    async btnClick (handleType) {
      if (handle[handleType]) {
        await handle[handleType](this.detail)
        this.getDetail()
      }
    }
  },
  computed: {
    priceList () {
      let rt = [
        { name: '合计', price: this.detail.changeAmount },
        { name: '新票价', price: this.detail.newTicketPrice },
        { name: '旧票价', price: this.detail.oldTicketPrice },
        { name: '改签差价', price: this.detail.priceDiff },
        { name: '改签手续费', price: this.detail.buyChangePoundage },
        { name: '服务费', price: this.detail.buyServiceCharge }
      ]
      return rt
    }
  }
}
</script>

<style lang="less">
.AlterCmp {

  .wrapper {
    padding-bottom: 100px;
  }

  p {
    margin: 0;
  }

  .pad5 {
    padding: 5px;
  }

  .pad8 {
    padding: 8px;
  }

  .mt5 {
    margin-top: 5px;
  }

  .round-sm {
    overflow: hidden;
  }

  .order-status__icon {
    vertical-align: middle;
  }

  .StopStation {
    >.van-row {
      color: @color-text-black;
    }
  }
}
</style>
